import { FC, useMemo } from 'react'

import { searchByWordPrefix } from '../utils'

import AutocompleteSelect, { FilterFunction } from './AutocompleteSelect'
import countriesList, { type Country3Codes, type CountryNames } from './countriesList'

type CountryType = {
    label: CountryNames
    value: Country3Codes
}

export interface Props {
    value: Country3Codes
    onChange: (value: Country3Codes | undefined) => void
    error?: string
    placeholder?: string
    disabled?: boolean
    filter?: FilterFunction
}

const CountryPicker: FC<Props> = ({
    value,
    onChange,
    disabled,
    error,
    placeholder = 'Country',
    filter,
    ...rest
}) => {
    const selectedValue = useMemo(() => {
        const c = countriesList.find((c) => c[2] === value)
        return c ? { label: c[0], value: c[2] } : null
    }, [value])

    return (
        <AutocompleteSelect
            error={error}
            label={placeholder}
            disabled={disabled}
            items={countriesList.map(([name, , threeLetterCode]) => ({
                value: threeLetterCode,
                label: name,
            }))}
            onChange={(country: CountryType | null) => {
                onChange(country?.value)
            }}
            value={selectedValue as CountryType}
            filter={filter || searchByWordPrefix}
            {...rest}
        />
    )
}

export default CountryPicker
